import { render } from "./AuthBase.vue?vue&type=template&id=6c1117ab&scoped=true"
import script from "./AuthBase.vue?vue&type=script&lang=js"
export * from "./AuthBase.vue?vue&type=script&lang=js"

import "./AuthBase.vue?vue&type=style&index=0&id=6c1117ab&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c1117ab"]])

export default __exports__